import { useParams } from "react-router-dom";
import SuggestionCard from "../components/common/SuggestionCard";
import { useNavigate } from "react-router-dom";
import { useProduct } from "../context/ProductContext";
import { useEffect, useState } from "react";

function ProductDetailPage() {
  //nos traemos el array con las pizzas
  const { pizzas } = useProduct();
  // 1. Obtener ID desde la url
  const { id } = useParams();

  const navigate = useNavigate();

  // 2. Cálculo del estado inicial (Debe hacerse antes de llamar a useState)
  // Usamos el operador ?. (optional chaining) para evitar errores si 'product' es null.

  /*nota importante: si se utiliza la tecnica de una sola request al servidor para cargar los productos
  en memoria dentro de un array como variable global, al recargar la página comprobar si el array llega vacío
  en caso de que si redirigir al usuario al menu*/

  const pizza = pizzas ? pizzas.filter((pizza) => pizza.id == id) : null;
  const defaultSize = pizza[0]?.prices ? pizza[0].prices[0] : null;

  // 3. ✅ HOOKS LLAMADOS PRIMERO (Esta es la sección correcta)
  const [selectedSize, setSelectedSize] = useState(defaultSize);

  const [quantity, setQuantity] = useState(1);
  const [pizzaToCart, setPizzaToCart] = useState({});

  useEffect(() => {
    if (pizzas.length === 0) {
      alert("Al recargar la página serás redirigido al menú");
      navigate("/menu");
    }
    //setQuantity(1);
    setSelectedSize(selectedSize);

    setPizzaToCart({
      productId: pizza[0]?.id,
      productName: pizza[0]?.name,
      size: selectedSize?.size,
      quantity: quantity,
      price: selectedSize?.price,
      image: pizza[0]?.image_link,
    });
  }, [selectedSize]);

  // 4. RETORNO CONDICIONAL (Debe ir DESPUÉS de todos los hooks)
  if (pizza.length === 0) {
    return <h1 className="page-padding">Redirigiendo...</h1>;
  }

  // 5. LÓGICA DE PRECIOS Y CARRITO (Solo se ejecuta si el producto existe)
  let currentPrice = 0;
  if (selectedSize != null) {
    currentPrice = selectedSize.price;
  } else if (pizza[0]?.price) {
    currentPrice = pizza[0].price;
  } else {
  }

  //sumar cantidad

  const handleQuantityPlus = () => {
    setQuantity(quantity + 1);
    setPizzaToCart((prevState) => ({
      ...prevState, // Copia las propiedades anteriores
      quantity: quantity + 1, // Actualiza solo la propiedad deseada
    }));
  };

  //restar cantidad
  const handleQuantityMinus = () => {
    setQuantity(quantity - 1);
    setPizzaToCart((prevState) => ({
      ...prevState, // Copia las propiedades anteriores
      quantity: quantity - 1, // Actualiza solo la propiedad deseada
    }));
  };

  const saveToLocalStorage = (item) => {
    const cart = JSON.parse(localStorage.getItem("pizzaDeliciaCart") || "[]");

    const existingIndex = cart.findIndex(
      (i) => i.productName === item.productName && i.size === item.size,
    );

    if (
      existingIndex > -1 &&
      existingIndex < existingIndex + 1 &&
      selectedSize.size === item.size &&
      item.productName === pizza[0].name
    ) {
      cart[existingIndex].quantity += item.quantity;
    } else {
      cart.push(item);
    }

    localStorage.setItem("pizzaDeliciaCart", JSON.stringify(cart));
  };

  const handleAddToCart = () => {
    if (pizza[0].prices && !selectedSize) {
      alert("Por favor, selecciona un tamaño antes de agregar al carrito.");
      return;
    }

    saveToLocalStorage(pizzaToCart);

    alert(
      `¡${pizzaToCart.productId} (${
        pizzaToCart.size || "Unidad"
      }) agregado al carrito!`,
    );
    setQuantity(1);
  };

  return (
    <div className="product-detail-page-container page-padding">
      <div
        className="product-detail-main d-flex flex-row justify-content-evenly flex-wrap"
        style={{ marginBottom: "40px" }}
      >
        <div className="product-detail-image">
          <img
            className="rounded"
            src={pizza[0]?.image_link}
            alt={pizza[0]?.name}
            width="473"
            height="275"
          />
        </div>

        <div className="product-detail-info">
          <h1>{pizza[0]?.name}</h1>
          <p className="product-description fs-6">{pizza[0]?.description}</p>

          <p className="product-price-display fs-5">${currentPrice} MXN</p>

          {/* Opciones de Tamaño */}
          {pizza[0]?.prices && (
            <div className="size-options">
              {pizza[0].prices.map((sizeName) => (
                <button
                  key={sizeName}
                  className={`size-btn ${
                    selectedSize === sizeName ? "active" : ""
                  } btn btn-add-cart`}
                  onClick={() => setSelectedSize(sizeName)}
                  style={{ margin: "5px" }}
                >
                  {sizeName.size}
                </button>
              ))}
            </div>
          )}

          {/* Input de Cantidad */}
          <div className="cart-controls">
            <button
              onClick={handleQuantityMinus}
              className="btn-quantity-control btn btn-secondary"
              style={{ margin: "5px" }}
              disabled={quantity <= 1}
            >
              -
            </button>
            <span className="current-quantity" style={{ margin: "5px" }}>
              {quantity}
            </span>
            <button
              onClick={handleQuantityPlus}
              className="btn-quantity-control btn btn-secondary"
              style={{ margin: "5px" }}
              disabled={quantity >= 10}
            >
              +
            </button>
          </div>

          <button
            className="btn btn-add-cart"
            onClick={handleAddToCart}
            style={{ width: "100%" }}
          >
            Agregar al carrito
          </button>
        </div>
      </div>

      <section className="suggestions-section">
        <h2 style={{ marginBottom: "10px" }}>
          Sugerencias para agregar a tu pedido
        </h2>
        <div className="suggestions-grid d-flex justify-content-evenly flex-wrap">
          <SuggestionCard />
        </div>
      </section>
    </div>
  );
}

export default ProductDetailPage;
